import axios from "axios";
import { getApiBaseUrl } from "../config/api";

const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    config.baseURL = getApiBaseUrl();
    return config;
  },
  (error) => Promise.reject(error),
);

// Request interceptor to add Bearer token from localStorage
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ADDRESS API

/**
 * 1. Add address
 * POST /address
 *
 * @param {Object} addressData - Address data
 * @param {string} addressData.name - Name for the address
 * @param {boolean} addressData.is_selected - Whether this address is selected
 * @param {string} addressData.title - Address title (Work, Home, Other)
 * @param {string} addressData.landmark - Landmark
 * @param {string} addressData.address_line_1 - Address line 1
 * @param {string} addressData.city - City
 * @param {number} addressData.latitude - Latitude
 * @param {number} addressData.longitude - Longitude
 * @param {string} addressData.contact_number - Contact number
 * @returns {Promise} - API response
 */
export const addAddress = (addressData) => {
  return api.post("/user/address", addressData);
};

/**
 * 2. Get all addresses
 * GET /address
 *
 * @returns {Promise} - List of all addresses
 */
export const getAllAddresses = () => {
  return api.get("/user/addresses");
};

/**
 * 3. Get address details by ID
 * GET /address/{id}
 *
 * @param {string|number} addressId - Address ID
 * @returns {Promise} - Address details
 */
export const getAddressDetails = (addressId) => {
  return api.get(`/user/address/${addressId}`);
};

export const selectAddress = (addressId) => {
  return api.put(`/user/address/${addressId}`, { is_selected: true });
};

export const editAddress = (addressId, payload) => {
  if (!addressId) {
    console.error("❌ editAddress: addressId is missing");
    return Promise.reject(new Error("addressId missing"));
  }

  console.log("✅ Editing address:", addressId);
  console.log("➡️ PUT /user/address/" + addressId);

  return api.put(`/user/address/${addressId}`, payload);
};

export const deleteAddress = (addressId) => {
  return api.delete(`/user/address/${addressId}`);
};

export default api;
